const AddorderShimmer = () => {
  return (
    <div className="flex flex-col space-y-6">
      {/* Customer select */}
      <div className="space-y-3">
        <div className="h-4 w-24 shimmer rounded" />
        <div className="h-11 w-full shimmer rounded-lg" />
        <div className="h-4 w-40 shimmer rounded self-end" />
      </div>

      {/* Meal select */}
      <div className="space-y-3">
        <div className="h-4 w-28 shimmer rounded" />
        <div className="h-11 w-full shimmer rounded-lg" />
      </div>

      {/* Selected meal card */}
      <div className="border border-gray-100 rounded-md p-4 space-y-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 shimmer rounded-md" />
            <div className="space-y-2">
              <div className="h-4 w-32 shimmer rounded" />
              <div className="h-4 w-20 shimmer rounded" />
            </div>
          </div>

          <div className="flex gap-3">
            <div className="h-8 w-8 shimmer rounded-md" />
            <div className="h-8 w-8 shimmer rounded-md" />
            <div className="h-8 w-8 shimmer rounded-md" />
          </div>
        </div>

        <div className="space-y-2">
          <div className="h-3 w-full shimmer rounded" />
          <div className="h-3 w-5/6 shimmer rounded" />
        </div>
      </div>

      {/* Extra items */}
      <div className="space-y-3">
        <div className="h-4 w-24 shimmer rounded" />

        {[1, 2].map((i) => (
          <div
            key={i}
            className="border border-gray-100 p-4 rounded-md flex justify-between items-center"
          >
            <div className="space-y-2">
              <div className="h-4 w-32 shimmer rounded" />
              <div className="h-4 w-20 shimmer rounded" />
            </div>

            <div className="flex gap-3">
              <div className="h-8 w-8 shimmer rounded-md" />
              <div className="h-8 w-8 shimmer rounded-md" />
              <div className="h-8 w-8 shimmer rounded-md" />
            </div>
          </div>
        ))}
      </div>

      {/* Trial + calendar */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 items-end">
        <div className="h-[72px] shimmer rounded-xl" />
        <div className="space-y-2">
          <div className="h-4 w-24 shimmer rounded" />
          <div className="h-11 w-full shimmer rounded-lg" />
        </div>
      </div>

      {/* Meal timing + delivery */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {[1, 2].map((i) => (
          <div key={i} className="space-y-3">
            <div className="h-4 w-32 shimmer rounded" />
            <div className="flex gap-3">
              <div className="h-9 w-24 shimmer rounded-full" />
              <div className="h-9 w-24 shimmer rounded-full" />
            </div>
          </div>
        ))}
      </div>

      {/* Address box */}
      <div className="h-16 w-full shimmer rounded-lg" />

      {/* Amount */}
      <div className="space-y-2">
        <div className="h-4 w-32 shimmer rounded" />
        <div className="h-11 w-full shimmer rounded-md" />
      </div>

      {/* Button */}
      <div className="mt-8 h-12 w-full bg-gray-300 rounded-xl" />
    </div>
  );
};

export default AddorderShimmer;
